import {PhotoProvider, PhotoConsumer} from "vue3-photo-preview";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('PhotoProvider', PhotoProvider);
  nuxtApp.vueApp.component('PhotoConsumer', PhotoConsumer);
});
